import moment from 'moment'

export const compareStrings = (a, b) => {
  return (
    a
      .toString()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase() ===
    b
      .toString()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
  )
}

export const compareDates = (a, b) => {
  return moment(a).isSame(moment(b), 'day')
}
